// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aYSrvypHGi4A83 {
  width: 100%;
}
.Fbe7uqRWDd5wRS {
  display: flex;
  width: 170px;
  height: 120px;
  margin: 24px auto;
}
.LbZp22q9meALDd {
  margin: 8px auto;
  text-align: center;
}
.QJImAnlOPikH3U {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.KonAfxfa1JG1Qy {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `aYSrvypHGi4A83`,
	"modalImage": `Fbe7uqRWDd5wRS`,
	"modalTitle": `LbZp22q9meALDd`,
	"modalText": `QJImAnlOPikH3U`,
	"buttonContainer": `KonAfxfa1JG1Qy`
};
export default ___CSS_LOADER_EXPORT___;
